import { PhoneNumberUtil } from 'google-libphonenumber'

const mobileParser = (input, dialCode, countryCode) => {
    const phoneUtil = PhoneNumberUtil.getInstance()
    let result = phoneUtil.parse(input, countryCode)
    result = '+' + dialCode + result.getNationalNumber()
    return result
}

export default mobileParser